import React from 'react'
import styled, {css} from "styled-components"

import { Link as InternalLink } from "gatsby"

import { typeBody02, typeBody03, typeBody03_bold, typeHeading02, typeHeading03, typeHeading04, typeHeading05, typeLabel02, typeLabel01 } from '../../theme/typography'

import { pixelate, unit, spacer, mediaQuery, SIZE } from '../../theme/metrics';
import { button } from '../../theme/core';
import { BLACK_01, WHITE_01, BLUE_01, GREY_01 } from '../../theme/colors';

export const Container = styled.header`
	height: ${unit(9)};
	width: 100%;
`

export const Content = styled.div`
	height: ${unit(9)};
	padding: 0 ${unit(3)};
	display: flex;
	z-index: 5;
	position: fixed;
	background-color: ${WHITE_01};
	width: 100%;

	${mediaQuery[SIZE.large]}{
		padding: 0 ${spacer(1)};
	}
`

export const Menu = styled.div`
	flex: 1;
	position: fixed;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
	background-color: ${WHITE_01};
	flex-direction: column-reverse;
	justify-content: flex-end;
	display: ${props => props.active ? `flex` : `none`};

	${mediaQuery[SIZE.large]}{
		display: flex;
		position: static;
		flex-direction: row;
		justify-content: flex-start;
		align-items: stretch;
	}
`

export const BurgerLabel = styled.span`
	${typeHeading05}
	height: ${unit(9)};
	display: block;
	position: relative;
	
`

export const Burger = styled.div`
	height: ${unit(9)};
	right: ${unit(3)};
	position: absolute;
	top: 0;
	display: flex;
	align-items: center;
	cursor: pointer;
	overflow: hidden;

	${BurgerLabel} {
		${props => props.active ? `top: ${unit(-9)};` : ``}
	}

	${mediaQuery[SIZE.large]}{
		display: none;
	}
`

export const BurgerIcon = styled.span`
	display: block;
	width: ${unit(3)};
	height: ${unit(2)};
	border-top: 2px solid ${BLACK_01};
	position: relative;
	box-sizing: border-box;
	margin: 0 ${unit(1)};

	&:before{
		content: "";
		position: absolute;
		width: ${unit(3)};
		height: 2px;
		background-color: ${BLACK_01};
		top: ${pixelate(unit(1,{pixelate:false}) - 3)};
	}

	&:after{
		content: "";
		position: absolute;
		width: ${unit(2)};
		height: 2px;
		background-color: ${BLACK_01};
		bottom: 0;
	}
`

export const BurgerOpen = styled.span`
	display: flex;
	align-items: center;
	height: ${unit(9)};
`

export const BurgerClose = styled.span`
	display: flex;
	align-items: center;
	height: ${unit(9)};
`

export const Navigation = styled.nav`
	display: flex;
	justify-content: space-between;
	flex-direction: column;
	flex: 1;
	overflow: auto;

	${mediaQuery[SIZE.large]}{
		flex-direction: row;
		overflow: visible;
	}
`

export const Logo = styled(InternalLink)`
	display: flex;
	align-items: center;
`

export const LogoMark = styled.svg`
	
`

export const NavigationList = styled.ul`
	display: block;

	${mediaQuery[SIZE.large]}{
		display: flex;
		flex-direction: row;
		margin: 0 ${unit(1.5)};
	}
`

export const NavigationListItem = styled.li`
	margin-bottom: ${unit(1)};
	display: block;
	
	${mediaQuery[SIZE.large]}{
		display: flex;
		margin: 0 ${unit(1.5)};
	}
`

export const NavigationLink = styled.a`
	${typeHeading02}
	display: flex;
	align-items: center;
	color: ${BLACK_01};
	text-decoration: none;
	padding: 0 ${unit(3)};
	transition: opacity 0.3s;

	&:hover{
		opacity: 0.6;
	}

	${mediaQuery[SIZE.large]}{
		${typeHeading05}
		padding: 0;
	}
`

export const Group = styled.div`
	position: relative;
	display: flex;
	flex-direction: column;
	justify-content: center;
`

export const GroupList = styled.ul`
	display: block;
	padding: ${unit(3)} 0;

	${mediaQuery[SIZE.large]}{
		display: block;
		position: absolute;
		top: 100%;
		width: ${unit(52)};
		background-color: ${WHITE_01};
		box-shadow: ${unit(1)} ${unit(1)} 0 0 rgba(0,0,0,0.1);
		padding: ${unit(3)};
		visibility: ${props => props.hover ? `visible` : `hidden`};
	}
`

export const GroupArrow = styled.svg`
	fill: ${BLUE_01};
	margin-left: ${unit(1)};
	display: none;

	${mediaQuery[SIZE.large]}{
		display: block;
	}
`

export const GroupListItem = styled.li`
	display: block;
	margin-bottom: ${unit(1)};

	&:last-child{
		margin-bottom: 0;
	}

	${mediaQuery[SIZE.large]}{
		margin-bottom: ${spacer(1)};
	}
`

export const GroupLink = styled.a`
	display: block;
	color: ${BLACK_01};
	text-decoration: none;
	padding: 0 ${unit(3)};
	transition: opacity 0.3s;

	&:hover{
		opacity: 0.6;
	}

	${mediaQuery[SIZE.large]}{
		padding: 0;
	}
`

export const GroupListItemIcon = styled.img`
	display: block;
`

export const GroupListItemLabel = styled.span`
	${typeHeading04}
	display: block;
	color: ${BLUE_01};

	${mediaQuery[SIZE.large]}{
		
		color: ${BLACK_01};
		margin-bottom: ${unit(0.5)};

		&:last-child{
			margin-bottom: 0;
		}
	}
`

export const GroupListItemDescription = styled.span`
	${typeBody03}
	display: none;

	${mediaQuery[SIZE.large]}{
		display: block;
	}
`

export const Locale = styled.div`
	display: flex;
	position: relative;
	align-items: center;

`

export const LocaleHeader = styled.div`
	
	padding: 0 ${unit(3)};
	height: ${unit(9)};
	display: flex;
	align-items: center;
	text-transform: uppercase;
	cursor: pointer;

	${mediaQuery[SIZE.large]}{
		border: 1px solid ${GREY_01};
		height: ${unit(6)};
		padding: 0 ${unit(2)};
	}
`

export const LocaleLabel = styled.p`
	${typeLabel02}
	color: ${BLACK_01};
	margin-left: ${unit(1)};
`

export const LocaleArrow = styled.svg`
	fill: ${BLUE_01};
	margin-left: ${unit(1)};
`

export const LocaleDropdown = styled.div`
	display: block;
	position: absolute;
	top: 100%;
	left: ${unit(3)};
	visibility: ${props => props.active ? `visible` : `hidden`};
	background-color: ${GREY_01};
	min-width: 160px;

	${mediaQuery[SIZE.large]}{
		background-color: ${WHITE_01};
		visibility: ${props => props.hover ? `visible` : `hidden`};
		right: 0;
		left: auto;
		box-shadow: ${unit(1)} ${unit(1)} 0 0 rgba(0,0,0,0.1);
	}
`

export const CountryFlag = styled.span`
	width: ${unit(2)};
	height: ${unit(2)};
	display: block;
	${props => props.code ? `background-image: url(/images/flags/${props.code}.svg);` : ``}
	background-size: cover;
	background-position: center center;
	border: 1px solid ${GREY_01};
`

export const LocaleLink = styled.a`
	color: ${props => props.selected ? BLUE_01 : BLACK_01};
	text-decoration: none;
	display: block;
	margin-right: ${unit(2)};
	padding-left: ${unit(2)};
	border-bottom: 1px solid ${GREY_01};
	display: flex;
	align-items: center;
	line-height: ${unit(6)};
	height: ${unit(6)};
	position: relative;
	transition: color 0.3s;

	${mediaQuery[SIZE.large]}{
		${props => props.selected && css`
			&:before{
				content: "";
				position: absolute;
				background-color: ${BLUE_01};
				width: 2px;
				height: 100%;
				top: 0;
				left: 0;
			}
		`}
	}

	&:hover{
		color: ${BLUE_01};
	}
`

export const CountryList = styled.ul`
	
`

export const CountryItem = styled.li`
	border-top: 1px solid ${GREY_01};
	padding: ${unit(1)} 0;
`

export const CountryLabel = styled.span`
	${typeBody03_bold}
	color: ${props => props.selected ? BLUE_01 : BLACK_01};
	text-decoration: none;
	padding: ${unit(0.5)} ${unit(2)};
	display: flex;
	position: relative;
	align-items: center;
    justify-content: space-between;
`

export const LanguageList = styled.ul`
	
`

export const LanguageItem = styled.li`

`

export const LanguageLabel = styled.a`
	${typeBody03}
	color: ${props => props.selected ? BLUE_01 : BLACK_01};
	text-decoration: none;
	display: block;
	padding: ${unit(0.5)} ${unit(2)};
	display: flex;
	position: relative;
	transition: color 0.3s;

	${mediaQuery[SIZE.large]}{
		${props => props.selected && css`
			&:before{
				content: "";
				position: absolute;
				background-color: ${BLUE_01};
				width: 2px;
				height: 100%;
				top: 0;
				left: 0;
			}
		`}
	}

	&:hover{
		color: ${BLUE_01};
	}
`

export const ButtonList = styled.ul`
	display: block;
	padding: ${unit(4)} 0;

	${mediaQuery[SIZE.large]}{
		display: flex;
		flex-direction: row;
		padding: 0;
		margin: 0 ${unit(1.5)};
	}
`

export const ButtonListItem = styled.li`
	display: block;
	margin: 0 ${unit(3)} ${unit(3)} ${unit(3)};

	&:last-child{
		margin: 0 ${unit(3)};
	}

	${mediaQuery[SIZE.large]}{
		display: flex;
		flex-direction: row;
		align-items: center;
		margin: 0 ${unit(1.5)};

		&:last-child{
			margin: 0 ${unit(1.5)};
		}
	}
`

export const ButtonLink = styled.a`
	${button}
	background-color: ${BLUE_01};
	border: 1px solid ${BLUE_01};
	color: ${WHITE_01};
	display: block;
	transition: background-color 0.3s, border 0.3s;

	&:hover{
		background-color: ${BLACK_01};
		border: 1px solid ${BLACK_01};
	}
`
